import { useState, useEffect } from "react";
import { useUserWallets } from "@/libs/apis/onboarding/user/useUserWallets/useUserWallets";

const useDoesUserHaveWallets = () => {
  const [userHasWallets, setUserHasWallets] = useState<boolean | undefined>(
    undefined,
  );
  const { isLoading, error, wallets } = useUserWallets();

  useEffect(() => {
    if (!isLoading) {
      if (wallets !== undefined && wallets.length > 0 && !error)
        setUserHasWallets(true);
      else setUserHasWallets(false);
    }
  }, [wallets, error, isLoading]);

  return userHasWallets;
};

export default useDoesUserHaveWallets;
